import React from "react";
import { cn } from "@/utils/utils";
import { ArrowDown, ArrowUp } from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";
import Text from "@/components/ui/text";
import { Button } from "@/components/ui/button";

export interface SortButtonProps {
  label: string;
  directionLabels: { asc: string; desc: string };
  onClick: () => void;
  isAsc?: boolean;
  className?: string;
}

const SortButton: React.FC<SortButtonProps> = ({
  label,
  directionLabels,
  onClick,
  isAsc = true,
  className
}) => {
  return (
    <Button
      variant="secondaryNoBg"
      className={cn("gap-[6px] border-transparent rounded-[6px]", className)}
      onClick={onClick}
      data-test={`sort-button-${label.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className="flex gap-[6px] items-center">
        <IconContainer size="sm" color="secondary">
          {isAsc ? <ArrowDown /> : <ArrowUp />}
        </IconContainer>
        <Text variant="bodySecondary">{label}</Text>
      </div>
      <Text>{isAsc ? directionLabels.asc : directionLabels.desc}</Text>
    </Button>
  );
};

export default SortButton;
